/*******************************************************
 ***************************************** google maps
 *******************************************************/

(function($, window, document, undefined) {
  'use strict';

  $.fn.officeMap = function () {

    var map;
    var geocoder;
    var scrollwheel = true;
    var myLatLng;
    var myLatLngCenter;
    var setZoom = 10;

    if( $(window).width() < 1200){
        scrollwheel = false;
    }

    function getAddress() {
      geocoder = new google.maps.Geocoder();
      var address = $('.contact-map-wrapper-canvas').data('address');
      if($('.contact-map-wrapper-canvas').data('zoom') != undefined){
        setZoom =  $('.contact-map-wrapper-canvas').data('zoom');
      }
      geocoder.geocode( { 'address': address}, function(results, status) {
        if (status == 'OK') {
          myLatLng = results[0].geometry.location.toJSON();
          initMap();
        } else {
          alert('Geocode was not successful for the following reason: ' + status);
        }
      });
    }

    function initMap() {
      console.log(setZoom);
      map = new google.maps.Map($('.contact-map-wrapper-canvas')[0], {
        center: myLatLng,
        draggable: scrollwheel,
        scrollwheel: false,
        disableDefaultUI: true,
        mapTypeId: google.maps.MapTypeId.ROADMAP,
        styles: [{"featureType":"water","elementType":"geometry","stylers":[{"color":"#e9e9e9"},{"lightness":17}]},{"featureType":"landscape","elementType":"geometry","stylers":[{"color":"#f5f5f5"},{"lightness":20}]},{"featureType":"road.highway","elementType":"geometry.fill","stylers":[{"color":"#ffffff"},{"lightness":17}]},{"featureType":"road.highway","elementType":"geometry.stroke","stylers":[{"color":"#ffffff"},{"lightness":29},{"weight":0.2}]},{"featureType":"road.arterial","elementType":"geometry","stylers":[{"color":"#ffffff"},{"lightness":18}]},{"featureType":"road.local","elementType":"geometry","stylers":[{"color":"#ffffff"},{"lightness":16}]},{"featureType":"poi","elementType":"geometry","stylers":[{"color":"#f5f5f5"},{"lightness":21}]},{"featureType":"poi.park","elementType":"geometry","stylers":[{"color":"#dedede"},{"lightness":21}]},{"elementType":"labels.text.stroke","stylers":[{"visibility":"on"},{"color":"#ffffff"},{"lightness":16}]},{"elementType":"labels.text.fill","stylers":[{"saturation":36},{"color":"#333333"},{"lightness":40}]},{"elementType":"labels.icon","stylers":[{"visibility":"off"}]},{"featureType":"transit","elementType":"geometry","stylers":[{"color":"#f2f2f2"},{"lightness":19}]},{"featureType":"administrative","elementType":"geometry.fill","stylers":[{"color":"#fefefe"},{"lightness":20}]},{"featureType":"administrative","elementType":"geometry.stroke","stylers":[{"color":"#fefefe"},{"lightness":17},{"weight":1.2}]}],
        zoom: setZoom
      });
      setMarker(myLatLng);

      // listen for the window resize event & trigger Google Maps to update too
      $(window).resize(function() {
        setTimeout(function(){
          map.setCenter(myLatLngCenter);
        }, 500)
      }).resize();
    }

    function setMarker(myLatLng) {
      var marker = new google.maps.Marker({
        position: myLatLng,
        animation: google.maps.Animation.DROP,
        map: map,
        icon: '/marker.png'
      });
    }

    getAddress();
  };

  $(function() {
    if(typeof google === 'object' && typeof google.maps === 'object' && $('.contact-map-wrapper-canvas').length > 0){
      $('.contact-map-wrapper-canvas').officeMap();
    }
  });


}(jQuery, this, document));